/* eslint-disable no-unused-expressions */
import React, {useEffect, useState} from 'react';
import './ControlDetail.css';
import {connect} from 'react-redux';
import {ControlDetailInfo} from '../ControlDetailInfo/ControlDetailInfo';
import * as PropertyBucket from '../../Properties/Properties';
import {Waiter} from '.././WaitingSign/Waiting';
import * as httpService from '../HttpService/HttpService';
import * as actionsControl from '../../Redux/Actions/Controls'
import PopUp from "../PopUp/PopUp";

export const GET_CONTROLS_REQUESTED = 'GET_CONTROLS_REQUESTED';
export const GET_CONTROLS_DONE = 'GET_CONTROLS_DONE';
export const GET_CONTROLS_FAILED = 'GET_CONTROLS_FAILED';

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch) => {
	return {
		controlData: (controlId) => dispatch(actionsControl.getSingleControlData(controlId))
	}
};

export const ControlDetailProvider = connect(mapStateToProps, mapDispatchToProps)(props => {

	const [controlId, setControlId] = useState();
	const [isWaiting, setIsWaiting] = useState(true);
	const [loadedControlData, setLoadedControlData] = useState(null);
	const [controlResponse, setControlResponse] = useState();
	const [showPopup, setShowPopup] = useState(false)
	const [popup, setPopup] = useState({notification: null, type: null, title: null})

	useEffect(() => {
		setControlId(props.match.params.controlId);
		const url = props.source === "my_controls" ? PropertyBucket.getMyControlDetailByControlId(props.match.params.controlId) : PropertyBucket.getPostControlDetailByControlId(props.match.params.controlId);
		setControlResponse(httpService.getService(url, 'GET'));
	}, []);
	
	useEffect(() => {
		if (controlId && controlResponse) {
			controlResponse
				.then(data => {
					setLoadedControlData(data);
					setIsWaiting(false);
				}).catch((error) => {
					setShowPopup(true)
					setPopup({
						notification: error.message || 'Nieznany błąd.',
						type: 'error',
						title: 'Błąd'
					}
			)
			})
		}
		document.title = `e-Kontrole | Szczegóły kontroli, projekt: ${loadedControlData?.project.number}`;
	}, [controlId, controlResponse, loadedControlData]);

	const goBack = () => {
		props.history.goBack();
	};

	let popUp;
	showPopup ?
		popUp = <PopUp
			type={popup.type}
			title={popup.title}
			notification={popup.notification}
			closePopUp={() => setShowPopup(false)}
		/> : null;
	return (
		<div>
			<button className='btn save-btn' id='plus_img_container' onClick={goBack}><i data-v-db6946bc='' aria-hidden='true'
			                                                                             className='v-icon material-icons theme--light v-list-text'>arrow_back</i><span>WRÓĆ</span>
			</button>

			<h3>Szczegóły kontroli </h3>
			{isWaiting === false ? <ControlDetailInfo control={loadedControlData}/> : null}
			{popUp}
			<div id='waiter'><Waiter loading={isWaiting}/></div>
		</div>
	);
});



